'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import Box from '@mui/material/Box';
import { BannerTitle } from '@/components/BannerTitle';
import { FocusImage } from '@/components/FocusImage';
import { Breadcrumbs } from '@/components/Layout/Breadcrumbs';
import { SiteContainer } from '@/components/Layout/SiteContainer';
import { PrimaryTitle } from '@/components/PrimaryTitle';
import type { CmsPageData } from '@/services/cms/pages/CmsPageData';
export interface PageTitleProps {
  pageData: CmsPageData;
}
export function PageTitle(t0) {
  const $ = _c(25);
  const {
    pageData: t1
  } = t0;
  const {
    title,
    showTitle,
    bannerImage,
    breadcrumbs,
    showBreadcrumbs
  } = t1;
  if (!title || !showTitle) {
    return null;
  }
  if (bannerImage?.link) {
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        display: "flex",
        mb: 6,
        position: "relative",
        overflow: "hidden"
      };
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    let t3;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        position: "absolute",
        zIndex: "-1",
        top: "0",
        bottom: "0",
        left: "0",
        right: "0",
        width: "100%",
        height: "100%",
        objectFit: "cover"
      };
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    let t4;
    if ($[2] !== bannerImage) {
      t4 = <FocusImage priority={true} style={t3} {...bannerImage} />;
      $[2] = bannerImage;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        pt: 6,
        pb: 3,
        textAlign: "center",
        flexDirection: "column",
        display: "flex",
        alignItems: "center"
      };
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] !== title) {
      t6 = <BannerTitle>{title}</BannerTitle>;
      $[5] = title;
      $[6] = t6;
    } else {
      t6 = $[6];
    }
    let t7;
    if ($[7] !== breadcrumbs || $[8] !== showBreadcrumbs) {
      t7 = showBreadcrumbs ? <Breadcrumbs breadcrumbs={breadcrumbs} sx={{
        pt: 3
      }} variant="light" /> : null;
      $[7] = breadcrumbs;
      $[8] = showBreadcrumbs;
      $[9] = t7;
    } else {
      t7 = $[9];
    }
    let t8;
    if ($[10] !== t6 || $[11] !== t7) {
      t8 = <SiteContainer sx={t5}>{t6}{t7}</SiteContainer>;
      $[10] = t6;
      $[11] = t7;
      $[12] = t8;
    } else {
      t8 = $[12];
    }
    let t9;
    if ($[13] !== t4 || $[14] !== t8) {
      t9 = <Box sx={t2}>{t4}{t8}</Box>;
      $[13] = t4;
      $[14] = t8;
      $[15] = t9;
    } else {
      t9 = $[15];
    }
    return t9;
  }
  let t2;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      pt: 1,
      pb: 2
    };
    $[16] = t2;
  } else {
    t2 = $[16];
  }
  let t3;
  if ($[17] !== breadcrumbs || $[18] !== showBreadcrumbs) {
    t3 = showBreadcrumbs ? <Breadcrumbs breadcrumbs={breadcrumbs} sx={{
      pt: 0
    }} /> : null;
    $[17] = breadcrumbs;
    $[18] = showBreadcrumbs;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== title) {
    t4 = <PrimaryTitle>{title}</PrimaryTitle>;
    $[20] = title;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== t3 || $[23] !== t4) {
    t5 = <SiteContainer sx={t2}>{t3}{t4}</SiteContainer>;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  return t5;
}